(function () {

    /*
    * Ottimizzazione riproduzione multi-video
    * */

    // Flag globali (calcolati una volta)
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const prefersReducedData   = window.matchMedia?.('(prefers-reduced-data: reduce)').matches === true;
    const saveData             = (navigator.connection && navigator.connection.saveData) === true;

    // Se l'utente non vuole movimento o vuole risparmiare dati: non carichiamo i video
    if (prefersReducedMotion || prefersReducedData || saveData) {
        // Lascia i poster e non idratare le sorgenti
        return;
    }

    // Selettore per tutti i video da gestire
    const videos = Array.from(document.querySelectorAll('video[data-autoplay-video]'));
    if (!videos.length) return;

    // Utility: prepara il video per l'autoplay inline su iOS/Safari
    const primeForAutoplay = (v) => {
        v.muted = true;           // richiesto per autoplay
        v.defaultMuted = true;    // aiuta Safari
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('webkit-playsinline', '');
    };

    // Utility: idrata le <source> data-src => src una sola volta
    const hydrateSources = (v) => {
        if (v.__hydrated) return;
        const sources = v.querySelectorAll('source[data-src]');
        sources.forEach(s => {
            if (!s.src) s.src = s.getAttribute('data-src');
            s.removeAttribute('data-src');
        });
        v.__hydrated = true;
        v.load();
    };

    // Utility: tenta il play con retry "gentile"
    const tryPlay = (v) => {
        const p = v.play();
        if (p && typeof p.catch === 'function') {
            p.catch(() => {
                setTimeout(() => v.play().catch(()=>{}), 80);
            });
        }
    };

    // Prepara tutti i video
    videos.forEach(primeForAutoplay);

    // Un solo IntersectionObserver per tutti i video
    const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
            const v = e.target;

            if (e.isIntersecting) {
                // Entra in viewport: idrata (lazy) e avvia
                hydrateSources(v);
                tryPlay(v);
            } else {
                // Esce dal viewport: opzionale — metti in pausa per risparmiare risorse
                // Commenta la riga sotto se vuoi che continuino a loopare anche fuori schermo
                v.pause();
            }
        }
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    videos.forEach(v => io.observe(v));

    // Se alcune sorgenti sono già presenti (es. <link rel="preload"> ha fatto il suo),
    // prova comunque a far partire i video già idratati che sono in viewport.
    const kickVisibleAlreadyHydrated = () => {
        videos.forEach(v => {
            const hasRealSource = !!v.querySelector('source:not([data-src])');
            if (hasRealSource && isElementInViewport(v)) {
                tryPlay(v);
            }
        });
    };

    const isElementInViewport = (el) => {
        const r = el.getBoundingClientRect();
        return r.bottom > 0 && r.right > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight) && r.left < (window.innerWidth || document.documentElement.clientWidth);
    };

    kickVisibleAlreadyHydrated();

    // Riprendi il loop al ritorno dalla bfcache
    window.addEventListener('pageshow', (e) => {
        if (e.persisted) {
            videos.forEach(v => {
                if (isElementInViewport(v)) tryPlay(v);
            });
        }
    });

    // Pausa quando la scheda è nascosta (risparmio batteria)
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            videos.forEach(v => v.pause());
        } else {
            videos.forEach(v => {
                if (isElementInViewport(v)) tryPlay(v);
            });
        }
    }, false);
})();
